export { default as Label } from './label';
